module.exports = __webpack_public_path__ + "img/warning.a2d75b31.svg";